import { getToken, getUserData } from '@common';
import { LocalStorageItem, NavigationPathKey, UserRole } from '@enums';



import React, {useEffect, useState} from 'react'



import { useJwt } from 'react-jwt';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import {getAllCompanies} from '../api/endpoints/company/api'


interface Props {
  allowedRoles: UserRole[]
}
export const PrivateRoutes = (props: Props) => {
  const {allowedRoles} = props
  const currentUser = getUserData()
  const location = useLocation()
  const [authenticated, setAuthenticated] = useState(true)

  useEffect(() => {
    // Check authentication via API call to /api/user/me
    const checkAuth = async () => {
      try {
        await getAllCompanies();
      } catch (error) {
        // Not authenticated - redirect to login
        localStorage.removeItem(LocalStorageItem.AUTHENTICATION)
        console.log("Setting auth to false")
        setAuthenticated(false)
      }
    }

    checkAuth()
  }, [location])


  console.log({currentUser, authenticated})

  if (authenticated && !!currentUser) {
    console.log("Autehntciated!!")
    if (!currentUser || !allowedRoles.includes(currentUser?.role)) {
      return <Navigate to={NavigationPathKey.DASHBOARD} />
    }
    return <Outlet />
  } else {
    console.log("NOOO Autehntciated!!")
    return <Navigate to={NavigationPathKey.LOGIN} />

  }
}
